(ns ycweb.app.blitz.unpacking.unpacking
  (:require
   [ycweb.components.forms :as forms]
   [rum.core :as rum]
   [ycweb.util.core :as u]
   [ycweb.components.grid :as grid]
   [ycweb.components.transitions :as t]
   [ycweb.components.flow :as flow]
   [ycweb.components.toaster :as toaster]
   [ycweb.util.comms :as comms]
   [util.string :as str]
   [ycweb.components.wrapper :as w]
   [ycweb.components.common :as cmn]
   [ycweb.util.sound :as sound]))

(def steps
  (forms/setup-steps
    [{:key :fromlocation :title "Scan location to Unpack"}
     {:key :item-scan :title "Unpack Item"}
     {:key :tolocation :title "Scan location to Unpack onto"}
     {:key :items :title "Scan Items to Unpack"}]))

(defmethod comms/receive :unpacking/item-scan [app-atom {:keys [items]}]
  (let [{:keys [scan-qty scanned]} (cmn/curact app-atom :unpacking)]
    (toaster/close-subtle-progress app-atom)
    (sound/play :scan)
    (cond
      items
      (do
        (swap! app-atom assoc-in [:unpacking :items] items)
        (t/transition-next app-atom :unpacking/item-scan))

      :else
      (do
        (swap! app-atom assoc-in [:unpacking :scanned] (+ scan-qty scanned))
        (t/transition-next app-atom :unpacking/items)))))

(defmethod flow/barcode-dispatch-screen :unpacking/items [_ app-atom scan]
  (let [{:keys [session fromlocation tolocation scan-qty]} (cmn/curact app-atom :unpacking)]
    (toaster/open-subtle-progress app-atom)
    (comms/send :unpacking/item-scan
      {:session-id (:id session)
       :scan scan
       :qty scan-qty
       :tolocation-id (:id tolocation)
       :fromlocation-id (:id fromlocation)})))

(defmethod grid/modal-config :unpacking/change-location-modal [_ _ _]
  {:body grid/single-input-modal-body
   :footer grid/single-input-modal-footer
   :modal-type :alert})

(defmethod flow/barcode-dispatch-modal :unpacking/change-location-modal [_ app-atom scan]
  (grid/dispatch-action app-atom :unpacking/shelf-scan
    {:scan scan}))

(defmethod grid/action :unpacking/change-location [app-atom _ _]
  (grid/open-modal app-atom :unpacking/change-location-modal
    {:config
     {:title "Change location"
      :field-text "Location"
      :initial-value ""
      :save-text "Capture"
      :save-key :unpacking/shelf-scan
      :input-key :scan
      :input-type :barcode}}))

(defmethod grid/action :unpacking/adjust-qty [app-atom {:keys [qty]} _]
  (cond
    (not (cmn/curact app-atom [:unpacking :allowbulk?]))
    (toaster/open-toast app-atom :error "You lack the Unpack qty permission" {})

    (<= qty 0)
    (toaster/open-toast app-atom :error (str "Cannot move " qty " per scan") {})

    :else
    (swap! app-atom assoc-in [:unpacking :scan-qty] qty)))

(defmethod grid/action :unpacking/manual-qty [app-atom _ _]
  (grid/single-input-modal app-atom
    {:title "Capture manual quantity"
     :field-text "Quantity"
     :initial-value 1
     :save-text "Capture"
     :save-key :unpacking/adjust-qty
     :input-key :qty
     :input-type :number}))

(rum/defc items < rum/reactive [app-atom]
  (let [{:keys [fromlocation tolocation selected-item scanned]} (cmn/curact app-atom :unpacking)
        {:keys [features brand product qty images barcode]} selected-item]

    (w/wrapper app-atom "Move Stock"
      {:steps steps :step :items
       :modal-fn
       #(grid/menu-modal app-atom
          {:items
           [{:label "Change Location"
             :action :unpacking/change-location}
            {:label "Manual Qty"
             :action :unpacking/manual-qty}
            {:label "Close"
             :action :unpacking/cancel-modal
             :style
             {:full true :large true :text-link true :on-dark true}}]})}
      [[:div.section
        [:h2.u-text-center.heading
         {:class (u/bem :heading [:standard :flush])}
         "Scan items and put onto shelf:"]
        [:h2.u-text-center
         {:class (u/bem :heading [:large])}
         [:b (:name tolocation)]
         [:span.heading__subtext
          (str (str/capitalize (:location_type fromlocation)) ": ") [:b (:name fromlocation)]]]]
       [:div.slats
        [:article.card.product-card
         [:figure.product-card__hero
          [:span.product-card__scan-count (str (or scanned 0) " / " (or qty 0))]
          [:img.product-card__image
           {:src (u/cloudinary (:public_id (first images)) {:c "lpad"}) :alt ""}]]
         [:div.product-card__content
          [:h1.product-card__title
           [:span.product-card__brand brand]
           [:span.product-card__name product]]
          (when (u/presence features)
            [:div.product-card__variation-wrapper
             "Variation: " [:span.product-card__variation features]])
          [:div.product-card__barcode
           "Barcode: " [:b.u-barcode.u-block barcode]]]]]]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Scan Items"
         :right-plain true}))))

(defmethod flow/render-screen :unpacking/items [app-atom _]
  (items app-atom))

(defmethod comms/receive :unpacking/shelf-scan [app-atom {:keys [tolocation]}]
  (toaster/close-subtle-progress app-atom)
  (sound/play :scan)
  (swap! app-atom update :unpacking assoc
    :tolocation tolocation
    :scan-qty 1)
  (t/transition-next app-atom :unpacking/items))

(defmethod grid/action :unpacking/shelf-scan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :unpacking/shelf-scan
    {:scan scan}))

(defmethod flow/barcode-dispatch-screen :unpacking/scan-shelf [_ app-atom scan]
  (grid/dispatch-action app-atom :unpacking/shelf-scan {:scan scan}))

(rum/defc scan-shelf < rum/reactive [app-atom]
  (let [{:keys [fromlocation selected-item scanned]} (cmn/curact app-atom :unpacking)
        {:keys [features brand product dest qty images barcode]} selected-item]
    (w/wrapper app-atom "Move Stock" {:steps steps :step :tolocation}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard :flush])}
         "Scan Location to start Moving Items"]
        [:h2.u-text-center
         {:class (u/bem :heading [:large])}
         [:b dest]
         [:span.heading__subtext
          (str (str/capitalize (:location_type fromlocation)) ": ") [:b (:name fromlocation)]]]]
       [:div.slats
        [:article.card
         {:class (u/bem :product-card [:is-disabled])}
         [:figure.product-card__hero
          [:span.product-card__scan-count (str (or scanned 0) " / " (or qty 0))]
          [:img.product-card__image
           {:src (u/cloudinary (:public_id (first images)) {:c "lpad"}) :alt ""}]]
         [:div.product-card__content
          [:h1.product-card__title
           [:span.product-card__brand brand]
           [:span.product-card__name product]]
          (when (u/presence features)
            [:div.product-card__variation-wrapper
             "Variation: " [:span.product-card__variation features]])
          [:div.product-card__barcode
           "Barcode: " [:b.u-barcode.u-block barcode]]
          [:div.product-card__footnote]]]]]
      []
      (grid/pos-call-to-action
        {:left-fn
         #(grid/dispatch-action app-atom :unpacking/fromlocation
            {:scan (:barcode fromlocation)})
         :right-text "Scan Location"
         :right-plain true}))))

(defmethod flow/render-screen :unpacking/scan-shelf [app-atom _]
  (scan-shelf app-atom))

(defmethod comms/receive :unpacking/select [app-atom {:keys [selected-item]}]
  (toaster/close-subtle-progress app-atom)
  (sound/play :scan)
  (swap! app-atom update :unpacking assoc
    :selected-item selected-item
    :scanned 0)
  (t/transition-next app-atom :unpacking/scan-shelf))

(defmethod flow/barcode-dispatch-screen :unpacking/item-scan [_ app-atom scan]
  (toaster/open-subtle-progress app-atom)
  (comms/send :unpacking/select
    {:scan scan
     :fromlocation-id (cmn/curact app-atom [:unpacking :fromlocation :id])}))

(defmethod comms/receive :unpacking/bulk-drop [app-atom _]
  (toaster/close-subtle-progress app-atom)
  (sound/play :scan)
  (t/transition-next app-atom :unpacking/fromlocation))

(defmethod grid/action :unpacking/drop-location [app-atom {:keys [location-barcode]} _]
  (cond
    (not (cmn/curact app-atom [:unpacking :allowbulk?]))
    (toaster/open-toast app-atom :error "You lack the Unpack qty permission" {})

    :else
    (do
      (toaster/open-subtle-progress app-atom)
      (comms/send :unpacking/bulk-drop
        {:tolocation-barcode location-barcode
         :fromlocation-id (cmn/curact app-atom [:unpacking :fromlocation :id])}))))

(defmethod grid/modal-config :unpacking/modal-bulk-drop [_ _ _]
  {:body grid/single-input-modal-body
   :footer grid/single-input-modal-footer
   :modal-type :alert})

(defmethod flow/barcode-dispatch-modal :unpacking/modal-bulk-drop [_ app-atom scan]
  (grid/dispatch-action app-atom :unpacking/drop-location
    {:location-barcode scan}))

(defmethod grid/action :unpacking/bulk-drop-menu [app-atom _ _]
  (grid/open-modal app-atom :unpacking/modal-bulk-drop
    {:config
     {:title "Bulk drop to another location"
      :field-text "Location"
      :initial-value ""
      :save-text "Capture"
      :save-key :unpacking/drop-location
      :input-key :location-barcode
      :input-type :barcode}}))

(rum/defc item-slat < rum/reactive [selected-item]
  [:article.slat.product-slat.product-slat--pulse-plus
   [:div.product-slat__qty
    [:span (:qty selected-item)]]
   [:div.product-slat__info
    [:header.product-slat__header
     [:div.product-slat__title-wrapper
      [:h1.product-slat__title [:span.product-slat__brand (:brand selected-item)] (:product selected-item)]]]
    [:div.product-slat__details
     [:span.product-slat__variation (:features selected-item)]
     [:span.product-slat__barcode
      [:b.u-barcode (:barcode selected-item)]]]]])

(rum/defc item-scan < rum/reactive [app-atom]
  (let [{:keys [items fromlocation]} (cmn/curact app-atom :unpacking)]
    (w/wrapper app-atom "Move Stock"
      {:steps steps :step :item-scan
       :modal-fn
       #(grid/menu-modal app-atom
          {:items
           [{:label "Bulk Drop"
             :action :unpacking/bulk-drop-menu}
            {:label "Close"
             :action :unpacking/cancel-modal
             :style
             {:full true :large true :text-link true :on-dark true}}]})}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Scan Item to start moving stock"
         [:span {:class "heading__subtext"}
          "Location: " [:b (:barcode fromlocation)]]]]
       [:div.slats
        (map item-slat items)]]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Scan Item"
         :right-plain true}))))

(defmethod flow/render-screen :unpacking/item-scan [app-atom _]
  (item-scan app-atom))

(defmethod comms/receive :unpacking/start [app-atom {:keys [fromlocation items allowbulk?]}]
  (toaster/close-subtle-progress app-atom)
  (sound/play :scan)
  (swap! app-atom update :unpacking assoc
    :fromlocation fromlocation
    :items items
    :allowbulk? allowbulk?)
  (t/transition-next app-atom :unpacking/item-scan))

(defmethod grid/action :unpacking/fromlocation [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :unpacking/start {:scan scan}))

(defmethod flow/barcode-dispatch-screen :unpacking/fromlocation [_ app-atom scan]
  (grid/dispatch-action app-atom :unpacking/fromlocation {:scan scan}))

(rum/defc fromlocation < rum/reactive [app-atom]
  (w/wrapper app-atom "Move Stock" {:steps steps :step :fromlocation}
    [[:div.section
      [:h2.u-text-center
       {:class (u/bem :heading [:standard])}
       "Scan Location"
       [:span.heading__subtext
        "to start moving stock"]]
      grid/barcode-icon]]
    []
    (grid/pos-call-to-action
      {:left-fn #(t/transition-next app-atom :main-menu)
       :right-text "Scan to Unpack"
       :right-plain true})))

(defmethod flow/render-screen :unpacking/fromlocation [app-atom _]
  (fromlocation app-atom))